import type { App, Plugin } from 'vue'
import components from './components'
import { version } from './package.json'
import * as plugins from './plugins'
// import type { RouteRecordRaw } from 'vue-router'

const INSTALLED_KEY = Symbol('INSTALLED_KEY')
const provideGlobalConfig = (config, app) => {}
export type EpOptions = {
  // routes?: RouteRecordRaw
}
export const install = (app: App, options?: EpOptions) => {
  if (app[INSTALLED_KEY]) return // 防止多次use导致重复安装注册,控制台警告
  app[INSTALLED_KEY] = true
  components.forEach((c) => app.use(c))
  Object.values(plugins).forEach((p) => app.use(p))
  if (options) {
    provideGlobalConfig(options, app)
  }
}

const plugin: Plugin & { version: string } = {
  install,
  version,
}
export default plugin
export * from '@el-plus/components/index'
export * from '@el-plus/hooks'
export * from '@el-plus/directives'
